import React from "react";
import { Form } from "react-crud-form";
import { FormField, FormItem, FormMessage } from "ui/components/form";
import { Input } from "ui/components/input";
import { Label } from "ui/components/label";
import { useNavigate } from "react-router-dom";
import SelectStatus from "components/select/status";
import { skillSchema } from "./schema";
import { FormActions } from "components/form/actions";
import { useSkillForm } from "./useSkillForm";
import FileInput from "components/file-upload/input";
import { PermissionControlledInput } from "permissions/components/input";
import { FormLabel } from "components/form";

const SkillsForm = ({ skillId }) => {
  const navigate = useNavigate();
  const { form, handleCreate, handleUpdate, handleRead } = useSkillForm({
    skillId,
  });

  return (
    <Form
      form={form}
      create={handleCreate}
      update={handleUpdate}
      read={handleRead}
      itemId={skillId || "+"}
      schema={skillSchema}
    >
      {({
        isCreating,
        createItem,
        isNewItem,
        updateItem,
        isUpdating,
        isDirty,
      }) => (
        <div className="space-y-6">
          {/* Logo */}
          <FormField
            control={form.control}
            name="logo"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:*"}
                  collection="skills"
                  type="form"
                >
                  <FormLabel required>Upload Logo</FormLabel>
                  <FileInput
                    className="size-44"
                    value={field.value}
                    onChange={field.onChange}
                  />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          {/* Name Field */}
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:*"}
                  collection="skills"
                  type="form"
                >
                  <FormLabel required>Name</FormLabel>
                  <Input {...field} />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormActions
            isNewItem={isNewItem}
            isCreating={isCreating}
            isUpdating={isUpdating}
            isDirty={isDirty}
            createItem={() => createItem().then(() => navigate(-1))}
            updateItem={() => updateItem().then(() => navigate(-1))}
            showCancel={false}
            collection="skills"
            rule={isNewItem ? "create:*" : "update:*"}
          />
        </div>
      )}
    </Form>
  );
};

export default SkillsForm;
